import { PureComponent } from 'react';
import { Input } from 'semantic-ui-react';

import withFormikInput from './withFormikInput';
import withFormField from './withFormField';

export class MoneyInput extends PureComponent {
  render() {
    // @ts-expect-error TS(2339): Property 'currencySymbol' does not exist on type '... Remove this comment to see the full error message
    const { currencySymbol, ...rest } = this.props;
    return <Input labelPosition="left" label={{ basic: true, content: currencySymbol }} {...rest} />;
  }
}

const FormMoneyInput = withFormikInput(withFormField(MoneyInput));
export default FormMoneyInput;
